import { useStoreState } from "easy-peasy";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@mui/material";

export default function Loading() {
  const loading = useStoreState(state => state.loading);

  return (
    <>
      {loading.visibility && (
        <StyledWrapper>
          <CircularProgress size={70} sx={{ color: "var(--teleforce-600)" }} />
          {loading.message !== "" && <StyledText>{loading.message}</StyledText>}
        </StyledWrapper>
      )}
    </>
  );
}

const StyledWrapper = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  zIndex: 9999
}));

const StyledText = styled("div")({
  color: "var(--teleforce-500)",
  fontSize: "1.5rem",
  marginTop: "1.5rem"
});
